// Posisi produksi Jahit (baca-saja) di detail varian stok Menipis/Habis.
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const num = (v) => (v === null || v === undefined ? "—" : v);
const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }) : "—");

export const showJahitPosition = (v) => !!v && v.category !== "kain";

function Box({ label, value, id }) {
  return <div className="jp-box" data-testid={`jahit-pos-${id}`}><span>{label}</span><b>{num(value)}</b><small>pcs</small></div>;
}

export function JahitPosition({ variantId }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { const r = await axios.get(`${API}/stock/variants/${variantId}/jahit-position`, { withCredentials: true, timeout: 20000 }); setD(r.data); }
    catch (e) { setD({ state: "error", message: e?.response?.data?.detail || "Aplikasi Jahit tidak dapat dihubungi", checked_at: new Date().toISOString() }); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, [variantId]); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className="jp-card" data-testid="jahit-position">
    <div className="jp-head"><b>Posisi produksi barang ini (Jahit)</b>
      <button type="button" className="soft-btn small-btn" onClick={load} disabled={busy} data-testid="jahit-pos-refresh">{busy ? "Memeriksa…" : "Periksa ulang"}</button></div>
    {!d && <p className="muted small">Memeriksa aplikasi Jahit…</p>}
    {d?.state === "found" && <>
      <div className="jp-grid">
        <Box label="Hasil Potong" value={d.hasil_potong} id="potong"/>
        <Box label="Sedang di jahit" value={d.sedang_dijahit} id="sedang"/>
        <Box label="Hasil Jahit" value={d.hasil_jahit} id="hasil"/>
      </div>
      <p className="muted small" data-testid="jahit-pos-match">Dicocokkan di Jahit: {d.product_name} · {(d.matched_colors || []).join(", ")}</p>
      {d.hasil_jahit > 0 && <p className="small" data-testid="jahit-pos-note">Ada {d.hasil_jahit} pcs hasil jahit yang belum diterima Gudang Rido.</p>}
      <p className="muted small">Barang di Jahit belum termasuk stok tersedia Gudang.</p>
    </>}
    {d?.state === "not_found" && <p className="small" data-testid="jahit-pos-not-found">{d.message}</p>}
    {d?.state === "error" && <p className="small jp-err" data-testid="jahit-pos-error">Gagal memeriksa Jahit: {d.message}. Ini bukan berarti produksi kosong.</p>}
    {d && <p className="muted small" data-testid="jahit-pos-checked">Terakhir diperiksa {fmtTime(d.checked_at)}</p>}
  </div>;
}
